module.exports = __webpack_public_path__ + "static/media/466GriffinStNW_2018-06-05_28.712d2bd3.jpg";